import {takeEvery} from 'redux-saga/effects'
import {
  DATA_UPLOAD_CONVERT,
  DATA_UPLOAD_DELETE_DRAFT,
  DATA_UPLOAD_GET_CHUNKED_STATUS,
  DATA_UPLOAD_GET_DRAFT,
  DATA_UPLOAD_GET_DRAFT_JOB,
  DATA_UPLOAD_GET_DRAFT_TEMPLATE,
  DATA_UPLOAD_GET_SUBJECT_ALIASES,
  DATA_UPLOAD_GET_USE_CASES,
  DATA_UPLOAD_LIST_DRAFTS,
  DATA_UPLOAD_MARK_DRAFT_APPLIED,
  DATA_UPLOAD_PUT_SUBJECT_ALIASES,
  DATA_UPLOAD_SAVE_DRAFT_ANSWERS,
  DATA_UPLOAD_SEND_CHUNK,
  DATA_UPLOAD_START_CHUNKED,
  DATA_UPLOAD_ERP_EXTRACT,
  DATA_UPLOAD_ERP_PREVIEW,
  DATA_UPLOAD_ERP_CONFIRM_MAPPING,
  DATA_UPLOAD_ERP_PATCH_RECORD,
  DATA_UPLOAD_ERP_BULK_RECORDS,
  DATA_UPLOAD_ERP_IMPORT,
  DATA_UPLOAD_ERP_DROP,
  DATA_UPLOAD_ERP_DROP_GLANCE,
  DATA_UPLOAD_ERP_ISSUES_REPORT,
  DATA_UPLOAD_ERP_ISSUES_UPLOAD,
  DATA_UPLOAD_ERP_VERIFICATION_REPORT,
} from 'setup/redux/Actions/DataUpload/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* dataUploadSagas() {
  yield takeEvery(DATA_UPLOAD_GET_USE_CASES, fetchData)
  yield takeEvery(DATA_UPLOAD_CONVERT, fetchData)
  yield takeEvery(DATA_UPLOAD_START_CHUNKED, fetchData)
  yield takeEvery(DATA_UPLOAD_SEND_CHUNK, fetchData)
  yield takeEvery(DATA_UPLOAD_GET_CHUNKED_STATUS, fetchData)
  yield takeEvery(DATA_UPLOAD_LIST_DRAFTS, fetchData)
  yield takeEvery(DATA_UPLOAD_GET_DRAFT_JOB, fetchData)
  yield takeEvery(DATA_UPLOAD_GET_DRAFT_TEMPLATE, fetchData)
  yield takeEvery(DATA_UPLOAD_GET_DRAFT, fetchData)
  yield takeEvery(DATA_UPLOAD_DELETE_DRAFT, fetchData)
  yield takeEvery(DATA_UPLOAD_SAVE_DRAFT_ANSWERS, fetchData)
  yield takeEvery(DATA_UPLOAD_MARK_DRAFT_APPLIED, fetchData)
  yield takeEvery(DATA_UPLOAD_GET_SUBJECT_ALIASES, fetchData)
  yield takeEvery(DATA_UPLOAD_PUT_SUBJECT_ALIASES, fetchData)
  yield takeEvery(DATA_UPLOAD_ERP_EXTRACT, fetchData)
  yield takeEvery(DATA_UPLOAD_ERP_PREVIEW, fetchData)
  yield takeEvery(DATA_UPLOAD_ERP_CONFIRM_MAPPING, fetchData)
  yield takeEvery(DATA_UPLOAD_ERP_PATCH_RECORD, fetchData)
  yield takeEvery(DATA_UPLOAD_ERP_BULK_RECORDS, fetchData)
  yield takeEvery(DATA_UPLOAD_ERP_IMPORT, fetchData)
  yield takeEvery(DATA_UPLOAD_ERP_DROP, fetchData)
  yield takeEvery(DATA_UPLOAD_ERP_DROP_GLANCE, fetchData)
  yield takeEvery(DATA_UPLOAD_ERP_ISSUES_REPORT, fetchData)
  yield takeEvery(DATA_UPLOAD_ERP_ISSUES_UPLOAD, fetchData)
  yield takeEvery(DATA_UPLOAD_ERP_VERIFICATION_REPORT, fetchData)
}

export default dataUploadSagas
